function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_650",
  "data-name": "Group 650",
  transform: "translate(-1344 -881.883)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_631",
  "data-name": "Group 631",
  transform: "translate(1344 881.883)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_630",
  "data-name": "Group 630"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_625",
  "data-name": "Path 625",
  d: "M1367.5,883.948a7.239,7.239,0,0,0-10.126,0l-11.8,11.8a5.528,5.528,0,0,0,7.818,7.818l10.685-10.685a3.557,3.557,0,0,0-5.03-5.03l-10.22,10.22a.929.929,0,0,0,1.314,1.314l10.22-10.22a1.7,1.7,0,0,1,2.4,2.4l-10.685,10.685a3.67,3.67,0,0,1-5.19-5.19l11.8-11.8a5.383,5.383,0,0,1,7.614,7.611l-11.8,11.8a.929.929,0,0,0,1.209,1.412.914.914,0,0,0,.1-.1l11.8-11.8A7.239,7.239,0,0,0,1367.5,883.948Z",
  transform: "translate(-1344 -881.883)",
  fill: "#c3c3c3"
}))));

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.676,
    height: 24.426,
    viewBox: "0 0 25.676 24.426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.2c2a366e.svg";
export { ForwardRef as ReactComponent };